module.exports = __webpack_public_path__ + "img/JP.79d338b4.png";